export default __webpack_public_path__ + "static/r360-fisheye-animation-d86e59dbcf6ce6bd891b019851fa7d28.mp4";